import * as React from 'react';

function SvgPlus(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 28" {...props}>
      <path d="M22 11.5v3a1.5 1.5 0 01-1.5 1.5H14v6.5a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 018 22.5V16H1.5A1.5 1.5 0 010 14.5v-3A1.5 1.5 0 011.5 10H8V3.5A1.5 1.5 0 019.5 2h3A1.5 1.5 0 0114 3.5V10h6.5a1.5 1.5 0 011.5 1.5z" />
    </svg>
  );
}

export default SvgPlus;
